import { authApi } from "./auth";
import { cafeApi } from "./cafe";
import { youtubeApi } from "./youtube";
import { friendApi } from "./friend";
import { tournamentApi } from "./tournament";
import { areaApi } from "./area";
import { noticeApi } from "./notice";
import { reportApi } from "./report";
import { advertisementApi } from "./advertisement";
import { updateApi } from "./update";

const API = {
  ...authApi,
  ...cafeApi,
  ...youtubeApi,
  ...friendApi,
  ...tournamentApi,
  ...areaApi,
  ...noticeApi,
  ...reportApi,
  ...advertisementApi,
  ...updateApi,
};

export default API;
